import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const FormFieldsWrapper = styled.div`
    display: flex;
    gap: ${token('space.200', '16px')};
    flex-direction: column;
`;

export const HelpDeskFormWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${token('space.1000', '80px')};
    & form {
        width: 100%;

        & footer {
            margin-top: ${token('space.400', '32px')};
        }
    }
    flex-direction: column;
`;
